import asyncAction from 'modules/core/lib/asyncAction'
import { stringToDate } from 'modules/core/lib/dates'
import { Model } from 'modules/core/lib/mobx-rest'

export interface IContractVersionRequest {
  [key: string]: any
}

class ContractVersionRequest extends Model<IContractVersionRequest> {
  constructor(attr: IContractVersionRequest = {}) {
    super(attr)
  }

  static urlRoot() {
    return '/contracts/contract_version_requests'
  }

  get effectiveOn(): moment.Moment {
    return stringToDate(this.attributes.effective_on, 'backend')
  }

  get authorName(): string {
    return this.attributes.created_by_name || ''
  }

  get authorAvatarUrl(): string {
    return this.attributes.created_by_avatar || ''
  }

  /**
   * Approves the model
   */
  async approve() {
    const { success, value } = await asyncAction(() =>
      this.rpc('approve', {
        id: this.id,
      })
    )
    if (success) {
      this.set(value)
    }
    return { success }
  }

  /**
   * Rejects the model
   */
  async reject(reason?: string) {
    const { success, value } = await asyncAction(() =>
      this.rpc('reject', {
        id: this.id,
        reason: reason,
      })
    )
    if (success) {
      this.set(value)
    }
    return { success }
  }
}

export default ContractVersionRequest
